export class GetQueryExecutionResultResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "queryExecutionId",
            "baseName": "queryExecutionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<QueryExecutionResultColumn>",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<Array<string>>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalRowCount",
            "baseName": "totalRowCount",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GetQueryExecutionResultResponse.attributeTypeMap;
    }
    constructor() {
    }
}
